import './VersionError.css';

// VersionErrorPage.tsx
import React from "react";
import {IVersionError} from "../../models/IVersionError";

type Props = {
    error: IVersionError;
    clientVersion: string;
};

const VersionErrorPage: React.FC<Props> = ({ error, clientVersion }) => {
    const entries = Object.entries(error.links ?? {});
    const hasLinks = entries.length > 0;

    return (
        <main className="VersionError_container" role="alert" aria-live="polite">
            <section className="VersionError_card">
                <h1 className="VersionError_title">Version mismatch</h1>

                <p className="VersionError_subtitle">
                    The client you’re using is out of date. Please update to continue.
                </p>

                <div className="VersionError_versions">
                    <div className="VersionError_versionBlock">
                        <div className="VersionError_label">Your client version</div>
                        <div className="VersionError_value VersionError_value--yours">
                            {clientVersion || "—"}
                        </div>
                    </div>

                    <div className="VersionError_versionBlock">
                        <div className="VersionError_label">Required version</div>
                        <div className="VersionError_value VersionError_value--required">
                            {error.current_version || "—"}
                        </div>
                    </div>
                </div>

                {hasLinks && (
                    <div className="VersionError_downloads">
                        <div className="VersionError_downloadsTitle">
                            Download the latest client:
                        </div>
                        <ul className="VersionError_linksList">
                            {entries.map(([name, href]) => (
                                <li key={name} className="VersionError_linkItem">
                                    <a
                                        className="VersionError_link"
                                        href={href}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {!hasLinks && (
                    <div className="VersionError_noLinks">
                        No download links were provided by the server.
                    </div>
                )}
            </section>
        </main>
    );
};

export default VersionErrorPage;